import React from 'react';
import { InvoicingDocumentResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface InvoicingDocumentDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  invoicingDocument: InvoicingDocumentResponse | null;
}

export const InvoicingDocumentDeleteDialog: React.FC<InvoicingDocumentDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  invoicingDocument,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="invoicing-document"
      itemId={invoicingDocument?.id || ''}
    />
  );
};
